import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('pokerChipCalcModule');

export default {
    computed: {
        ...mapGetters(['t']),
    },
};
